module.exports = __webpack_public_path__ + "img/CL.2193593c.svg";